import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-2310a82c"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "detail-content"
};
const _hoisted_2 = {
  class: "base-info"
};
const _hoisted_3 = {
  class: "img-wrap"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "detail-info"
};
const _hoisted_6 = {
  class: "title"
};
const _hoisted_7 = {
  key: 0,
  class: "tags"
};
const _hoisted_8 = {
  class: "action-btn"
};
const _hoisted_9 = {
  class: "desc-wrap"
};
const _hoisted_10 = {
  class: "title"
};

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("em", {
  class: "work-line"
}, null, -1));

const _hoisted_12 = ["innerHTML"];
import { computed, ref, watch } from 'vue';
import DownloadCountIcon from './downloadCount-icon.vue';
import { timestampToDateTime } from '@/utils/data-format.js';
import statistic from './statistic.vue';
import useUserStore from '@/store/modules/user.js';
import LoginHintDialog from './login-hint-dialog.vue';
import { downloadIterm } from '@/service/detail/detail.js';
import { DevDownloadAPI } from '@/service/request/config.js';
import { isWeiXin } from '@/utils/user-agent.js';
import { ElMessage } from 'element-plus';
export default {
  __name: 'detail-content',
  props: {
    detailInfo: {
      type: Object,
      required: true
    }
  },

  setup(__props) {
    const props = __props;
    watch(() => props.detailInfo, newVal => {
      document.title = newVal.name + '｜深圳市共熵产业与标准创新服务中心';
    }, {
      deep: true,
      immediate: true
    });
    const imgUrl = computed(() => {
      return '/static/' + props.detailInfo.thumbnail;
    });
    const tagsArr = computed(() => {
      return props.detailInfo.tags.split(',');
    });
    const userStore = useUserStore();
    const loginHintDialogRef = ref(null);

    const handleToLogin = () => {
      loginHintDialogRef.value.dialogVisible = true;
    };

    const handleDownload = () => {
      if (userStore.token) {
        const data = {
          token: userStore.token,
          user_id: userStore.userInfo.user_id,
          item_id: props.detailInfo.id
        };
        downloadIterm(props.detailInfo.id, data).then(res => {
          if (res.success) {
            // inner download
            if (props.detailInfo.type == 1) {
              const downloadPath = `${DevDownloadAPI}/download/${res.result}`;
              window.location.href = downloadPath;
            } else {
              // outer download
              window.location.href = res.result;
            } // const isWeiXinUserAgent = isWeiXin()
            // if (isWeiXinUserAgent) {
            // } else {
            //   window.open(downloadPath)
            // }

          }
        }); // var blob = new Blob([data], { type: 'application/pdf' })
        // var objectUrl = URL.createObjectURL(blob)
        // var a = document.createElement('a')
        // document.body.appendChild(a)
        // a.setAttribute('style', 'display:none')
        // a.setAttribute('href', objectUrl)
        // // var filename = props.detailInfo.name
        // // a.setAttribute('download', filename)
        // a.click()
        // URL.revokeObjectURL(objectUrl)
      } else {
        handleToLogin();
      }
    };

    return (_ctx, _cache) => {
      const _component_el_tag = _resolveComponent("el-tag");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_button = _resolveComponent("el-button");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
        src: imgUrl.value,
        class: "poster",
        alt: ""
      }, null, 8, _hoisted_4)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(__props.detailInfo.name), 1), __props.detailInfo.tags.length != '' ? (_openBlock(), _createElementBlock("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tagsArr.value, (item, index) => {
        return _openBlock(), _createBlock(_component_el_tag, {
          key: index,
          class: "tag-item"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item), 1)]),
          _: 2
        }, 1024);
      }), 128))])) : _createCommentVNode("", true), _createVNode(_component_el_row, {
        class: "data-account-pc"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 8
        }, {
          default: _withCtx(() => [_createVNode(statistic, {
            title: "更新日期",
            value: _unref(timestampToDateTime)(__props.detailInfo.upload_at)
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 8
        }, {
          default: _withCtx(() => [_createVNode(statistic, {
            title: "总下载量",
            value: __props.detailInfo.download_count + ''
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 8
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "data-account-mobile"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(statistic, {
            title: "更新日期",
            value: _unref(timestampToDateTime)(__props.detailInfo.upload_at),
            size: "16"
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(statistic, {
            title: "总下载量",
            value: __props.detailInfo.download_count + '',
            size: "16"
          }, null, 8, ["value"])]),
          _: 1
        })]),
        _: 1
      }), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_button, {
        type: "primary",
        onClick: handleDownload
      }, {
        default: _withCtx(() => [_createTextVNode("前往下载")]),
        _: 1
      })])])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("h2", null, _toDisplayString(__props.detailInfo.type == 1 ? '简介' : '联盟简介'), 1), _hoisted_11]), _createElementVNode("div", {
        class: "desc",
        innerHTML: __props.detailInfo.content
      }, null, 8, _hoisted_12)]), _createVNode(LoginHintDialog, {
        ref_key: "loginHintDialogRef",
        ref: loginHintDialogRef
      }, null, 512)]);
    };
  }

};